import { DataItem, DataItemStatus } from '@/components';
export function applyArrayChanges<T>(source: Iterable<DataItem<T>>, dest: Array<T>, comparer: (d: T, s: T) => boolean): Array<T> {
  Array.from(source).forEach(element => {

    switch (element.status) {
      case DataItemStatus.unchanged: return;
      case DataItemStatus.deleted:
        var idx = dest.findIndex(i => comparer(i, element.item));
        if (idx >= 0)
          dest.splice(idx, 1);
        return;
      case DataItemStatus.changed:
        var result = dest.find(i => comparer(i, element.item));
        if (result)
          Object.assign(result, element.item);
        else
          dest.push(element.item);
        return;
    }
  });
  return dest;
}